import { InfiniteTable } from '@/components/_common';
import EyeIcon from '@/components/_common/EyeIcon';
import { usePurchaseGrouped } from '@/core/domain/purchase/Purchase.hooks';
import { PurchaseGrouped } from '@/core/domain/purchase/Purchase.types';
import { getTableScrollX } from '@/utils/table';
import { Space } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useState } from 'react';
import PurchaseGroupingInactivesViewModal from './PurchaseGroupingInactivesViewModal';
import { useDisclosure } from '@/hooks';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  purchaseId: number;
}

const PurchasesGroupingsList: React.FC<Props> = ({ purchaseId }) => {
  const { data, isFetching } = usePurchaseGrouped(purchaseId);

  const [purchase, setPurchase] = useState<PurchaseGrouped>();
  const [modalVisible, modalVisibleAction] = useDisclosure();

  const handleSelectPurchase = (purchase: PurchaseGrouped) => {
    if (purchase) {
      setPurchase(purchase);
      modalVisibleAction.open();
    }
  };

  const handleCancel = () => {
    setPurchase(undefined);
    modalVisibleAction.close();
  };

  const columns: ColumnsType<PurchaseGrouped> = [
    {
      key: 'code',
      dataIndex: 'code',
      title: 'Código',
      ellipsis: true,
      width: 180,
      render: (value) => (value ? value : '-'),
    },
    {
      key: 'releaseDate',
      dataIndex: 'releaseDate',
      title: 'Data de lançamento',
      ellipsis: true,
      width: 300,
      render: (value) => moment(value).format('DD/MM/YYYY'),
    },
    {
      key: 'documentNumber',
      dataIndex: 'documentNumber',
      title: 'Número documento',
      ellipsis: true,
      width: 120,
    },
    {
      key: 'totalAmount',
      dataIndex: 'totalAmount',
      title: 'Valor',
      ellipsis: true,
      width: 120,
      render: (value: number) => formatterPrice(value),
    },
    {
      key: 'actions',
      title: 'Visualizar',
      render: (_, record) => (
        <Space>
          <EyeIcon
            iconProps={{
              onClick: () => handleSelectPurchase(record),
            }}
          />
        </Space>
      ),
      width: 100,
      fixed: 'right',
      align: 'right',
    },
  ];

  return (
    <>
      <InfiniteTable<PurchaseGrouped>
        columns={columns}
        dataSource={data?.length ? data : []}
        loading={isFetching}
        rowKey={(row) => row.id}
        scroll={{ x: getTableScrollX(columns) }}
      />

      <PurchaseGroupingInactivesViewModal
        purchase={purchase}
        open={modalVisible}
        onCancel={handleCancel}
      />
    </>
  );
};

export default PurchasesGroupingsList;
